







































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import EmptyStateTable from '@/componentsV2/molecules/EmptyStateTable/EmptyStateTable.vue';
import CustomerImportCampaignStatus from '@/componentsV2/molecules/CustomerImportCampaignStatus/CustomerImportCampaignStatus.vue';

import { ICustomerImport } from '@/models/customer-import';

import { IPaginationTableHeader } from '@/utils/PaginationUtils';
import { copyToClipboard } from '@/utils';

@Component({
  components: {
    Table,
    TableCell,
    TableHeader,
    TableRow,
    TableCard,
    EmptyStateTable,
    CustomerImportCampaignStatus
  }
})
export default class CustomersImportCampaignList extends Vue {
  @Prop() headers!: Record<string, IPaginationTableHeader>;
  @Prop() customers!: ICustomerImport[];

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  detail(rowData: any) {
    this.$router.push(`/performance/customer-center/${rowData.id}`);
  }

  handleCopy(text: string, successMsg = 'Copied text.') {
    copyToClipboard(text, () => {
      this.$notification(successMsg);
    });
  }

  getImportedAtMobile(text: string) {
    const index = text.indexOf(' ');

    return `Date added • ${text.slice(0, index)}`;
  }

  getNameOrEmailMobile(item: ICustomerImport) {
    if (item.firstName) return item.firstName + ' ' + item.lastName;
    if (item.email) return item.email;
    return '--';
  }
}
